import React from 'react'

import './CreateSuccess.scss'

function CreateSuccess(props) {
    return (
        <div className="CreateSuccess" data-test-id="usecase-create_success">
            <div className="SuccessContainer">
                <span className="SuccessText" data-test-id="success-text">
                    🦫 {props.msg} 🪵
                </span>
            </div>
        </div>
    )
}

export default CreateSuccess
